import { render, staticRenderFns } from "./card.component.vue?vue&type=template&id=c259f55e&scoped=true"
import script from "./card.component.vue?vue&type=script&lang=js"
export * from "./card.component.vue?vue&type=script&lang=js"
import style0 from "./card.component.vue?vue&type=style&index=0&id=c259f55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c259f55e",
  null
  
)

export default component.exports